<template>
<vx-card fixed-height="true">
    <div>
        <div style="margin: 0px 3px 0px 3px">
            <table align="center">
                <tr>
                    <td>
                        <ul class="flex mt-2">
                            <li>
                                <vs-radio v-model="tipo" class="ml-2" vs-name="radios1tipo" vs-value="0" @change="FiltrohistoricoGeneral();">Por fechas</vs-radio>
                            </li>
                            <li>
                                <vs-radio v-model="tipo" class="ml-2" vs-name="radios1tipo" vs-value="1" @change="FiltrohistoricoGeneral();">Todo</vs-radio>
                            </li>
                        </ul>
                    </td>
                </tr>
            </table>
            <table align="center" v-if="tipo == 0">
                <tr>
                    <td>
                        Desde:
                    </td>
                    <td>
                        <flat-pickr :config="configdateTimePicker" v-model="fechainicio" placeholder="Fecha desde" class="w-full" @input="FiltrohistoricoGeneral()" />
                    </td>
                    <td>
                        Hasta:
                    </td>
                    <td>
                        <flat-pickr :config="configdateTimePicker" v-model="fechafin" placeholder="Fecha hasta" class="w-full" @input="FiltrohistoricoGeneral()" />
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <vs-row>
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-table search :data="HistoricoStockProducto" :max-items="HistoricoStockProducto.length" no-data-text="No hay datos del histórico">
                <template slot="thead">
                    <vs-th sort-key="psh_id">
                        <div>
                            <vs-tooltip text="Filtrar" position="top">
                                <template>‎</template>
                                <span>Id</span>
                            </vs-tooltip>
                        </div>
                    </vs-th>
                    <vs-th>Valores Anteriores</vs-th>
                    <vs-th>Valores Actualizados</vs-th>
                    <vs-th>Usuario Editor</vs-th>
                    <vs-th sort-key="created_at">
                        <div>
                            <vs-tooltip text="Filtrar" position="top">
                                <template>‎</template>
                                <span>Fecha y Tipo de actualización</span>
                            </vs-tooltip>
                        </div>
                    </vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr v-for="(tr, k) in data" :key="k">
                        <vs-td width="100">{{ tr.psh_id }}</vs-td>
                        <vs-td width="150">
                            <div v-for="(oldValue, proCodigo) in tr.psh_old_values" :key="proCodigo">
                                <div><strong>{{ oldValue.pro_codigo }}:</strong></div>
                                <div>pro_reservar: {{ oldValue.pro_reservar }}</div>
                                <div>pro_stock: {{ oldValue.pro_stock }}</div>
                                <div>pro_stockCalmed: {{ oldValue.pro_stockCalmed }}</div>
                                <div>pro_deposito: {{ oldValue.pro_deposito }}</div>
                                <div>pro_depositoCalmed: {{ oldValue.pro_depositoCalmed }}</div>
                                <hr />
                            </div>
                        </vs-td>
                        <vs-td width="150">
                            <div v-for="(newValue, proCodigo) in tr.psh_new_values" :key="proCodigo">
                                <div><strong>{{ newValue.pro_codigo }}:</strong></div>
                                <div>pro_reservar: {{ newValue.pro_reservar }}</div>
                                <div>pro_stock: {{ newValue.pro_stock }}</div>
                                <div>pro_stockCalmed: {{ newValue.pro_stockCalmed }}</div>
                                <div>pro_deposito: {{ newValue.pro_deposito }}</div>
                                <div>pro_depositoCalmed: {{ newValue.pro_depositoCalmed }}</div>
                                <hr />
                            </div>
                        </vs-td>
                        <vs-td width="50">{{ tr.nombreeditor }}</vs-td>
                        <vs-td width="50">
                            {{ tr.created_at }}
                            <br>
                            <br>
                            <span v-if="tr.psh_tipo == 0">Textos y Guías Edición Masiva</span>
                            <span v-else-if="tr.psh_tipo == 1">Combos Edición Masiva</span>
                            <span v-else-if="tr.psh_tipo == 2">Movimiento no Operativo - Ingreso</span>
                            <span v-else-if="tr.psh_tipo == 3">Movimiento no Operativo - Egreso</span>
                            <span v-else-if="tr.psh_tipo == 4">Generación de documento de venta</span>
                            <span v-else-if="tr.psh_tipo == 5">Pedido de Guias anuladas</span>
                            <span v-else>Tipo no controlado</span>
                            <div v-if="tr.psh_tipo == 4">
                                <br>
                                {{ tr.psh_id_ven_codigo }}
                            </div>
                            <div v-if="tr.psh_tipo == 5">
                                <br>
                                id_pedido: {{ tr.id_pedido }}
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </vs-col>
    </vs-row>
    <br><br>
</vx-card>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
    data() {
        return {
            HistoricoStockProducto: [],
            tipo: 0,
            fechainicio: '',
            fechafin: '',
            configdateTimePicker: {
                // enableTime: true,
                dateFormat: 'Y-m-d',
            },
            isExecuting: false,
        };
    },
    components: {
        flatPickr,
    },
    mounted() {
        let me = this;
        me.FiltrohistoricoGeneral();
    },
    methods: {
        FiltrohistoricoGeneral() {
            let me = this;

            // Si ya está ejecutándose, no hacer nada
            if (me.isExecuting) {
                return;
            }

            // Marcar como en ejecución
            me.isExecuting = true;

            // console.log(me.tipo, "cual tipo es");

            if (me.tipo == 0) {
                me.HistoricoStockProducto = [];

                if (me.fechainicio === '' && me.fechafin === '') {
                    me.$vs.notify({
                        color: 'warning',
                        title: 'Mensaje',
                        text: 'Seleccione la fecha desde y la fecha hasta.',
                        time: 5000,
                    });
                    // console.log("NO EXISTE NADA");
                } else if (me.fechainicio === '' && me.fechafin !== '') {
                    me.$vs.notify({
                        color: 'warning',
                        title: 'Mensaje',
                        text: 'Seleccione la fecha desde.',
                        time: 5000,
                    });
                    // console.log("EXISTE SOLO FIN");
                } else if (me.fechainicio !== '' && me.fechafin === '') {
                    me.$vs.notify({
                        color: 'warning',
                        title: 'Mensaje',
                        text: 'Seleccione la fecha hasta.',
                        time: 5000,
                    });
                    // console.log("EXISTE SOLO INICIO");
                } else if (me.fechainicio !== '' && me.fechafin !== '') {
                    let fechaInicio = new Date(me.fechainicio);
                    let fechaFin = new Date(me.fechafin);

                    if (fechaFin < fechaInicio) {
                        me.fechafin = '';
                        me.$vs.notify({
                            color: 'warning',
                            title: 'Mensaje',
                            text: 'La fecha hasta no puede ser menor que la fecha desde.',
                            time: 5000,
                        });
                        console.log("Fecha hasta es menor que la fecha desde");
                    } else {
                        // console.log("EXISTE TODO");
                        me.GetTodoHistoricoxFecha();
                    }
                }
            } else if (me.tipo == 1) {
                me.fechainicio = '';
                me.fechafin = '';
                me.HistoricoStockProducto = [];
                me.GetTodoHistorico();
            }
            // Esperar 1.5 segundos antes de permitir que el método se ejecute de nuevo
            setTimeout(() => {
                me.isExecuting = false;
            }, 500); // 1500 milisegundos = 1.5 segundos
        },
        GetTodoHistoricoxFecha() {
            let me = this;
            me.$vs.loading();
            this.$http.get(this.$server_url + 'GetProductoStockHistoricoxFecha', {
                    params: {
                        fecha_created_desde: me.fechainicio,
                        fecha_created_hasta: me.fechafin
                    }
                })
                .then(function (res) {
                    // Asegúrate de que los valores sean parseados como objetos JSON
                    me.HistoricoStockProducto = res.data.map(item => {
                        // Parsear correctamente los valores antiguos y nuevos (primero el JSON externo)
                        try {
                            item.psh_old_values = JSON.parse(item.psh_old_values);
                            item.psh_new_values = JSON.parse(item.psh_new_values);

                            // Parsear los valores internos de cada código (por ejemplo, SMLL2, SMLL3)
                            Object.keys(item.psh_old_values).forEach(key => {
                                item.psh_old_values[key] = JSON.parse(item.psh_old_values[key]);
                            });

                            Object.keys(item.psh_new_values).forEach(key => {
                                item.psh_new_values[key] = JSON.parse(item.psh_new_values[key]);
                            });
                        } catch (error) {
                            console.error('Error al parsear los valores JSON:', error);
                        }
                        return item;
                    });
                    me.$vs.loading.close();
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close();
                });
        },
        GetTodoHistorico() {
            let me = this;
            me.$vs.loading();
            this.$http.get(this.$server_url + 'GetProductoStockHistorico')
                .then(function (res) {
                    // Asegúrate de que los valores sean parseados como objetos JSON
                    me.HistoricoStockProducto = res.data.map(item => {
                        // Parsear correctamente los valores antiguos y nuevos (primero el JSON externo)
                        try {
                            item.psh_old_values = JSON.parse(item.psh_old_values);
                            item.psh_new_values = JSON.parse(item.psh_new_values);

                            // Parsear los valores internos de cada código (por ejemplo, SMLL2, SMLL3)
                            Object.keys(item.psh_old_values).forEach(key => {
                                item.psh_old_values[key] = JSON.parse(item.psh_old_values[key]);
                            });

                            Object.keys(item.psh_new_values).forEach(key => {
                                item.psh_new_values[key] = JSON.parse(item.psh_new_values[key]);
                            });
                        } catch (error) {
                            console.error('Error al parsear los valores JSON:', error);
                        }
                        return item;
                    });
                    me.$vs.loading.close();
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close();
                });
        },
        getCancelar() {
            this.$emit('change', {
                verificaredicionmasivaactualizar: 2
            });
        },
    },
};
</script>
